/**
 * TermsOfServicePage
 *
 * Public, scrollable rendering of the Terms of Service, available at /terms.
 * Reuses the shared TermsContent component so the modal and the page never
 * drift out of sync (RULE #-2: zero duplication).
 */

import { ArrowLeft, FileText } from 'lucide-react';
import { TermsContent } from '../../components/legal';
import { useTranslation } from '../../hooks/useTranslation';

interface TermsOfServicePageProps {
  onNavigateHome: () => void;
}

export function TermsOfServicePage({ onNavigateHome }: TermsOfServicePageProps) {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-[#0a0015] text-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <button
          onClick={onNavigateHome}
          className="inline-flex items-center gap-2 text-white/60 hover:text-white mb-6 transition-colors min-h-[44px]"
        >
          <ArrowLeft className="h-4 w-4" />
          <span>{t('tos.page.backToApp')}</span>
        </button>

        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-purple-500 to-purple-700 rounded-2xl mb-5 shadow-lg shadow-purple-500/25">
            <FileText className="h-8 w-8 text-white" />
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold mb-3">{t('tos.title')}</h1>
          <p className="text-white/60">{t('tos.subtitle')}</p>
          <p className="mt-3 text-xs text-white/40">
            {t('tos.page.version')} 1.0 · {t('tos.page.lastUpdated')}: 2026-05-26
          </p>
        </div>

        <div className="space-y-6 bg-black/30 backdrop-blur-xl border border-white/10 rounded-2xl p-6 sm:p-8">
          <TermsContent />
        </div>
      </div>
    </div>
  );
}

export default TermsOfServicePage;
